module.exports = __webpack_public_path__ + "img/Deribit.4caba31f.png";